import { AccountType, CompanyType } from "@green0meter/api-client";

import { CompanyEditorFormData } from "./CompanyEditor.types";

export const accountTypeColors: Record<
  AccountType,
  "success" | "warning" | "info"
> = {
  [AccountType.Real]: "success",
  [AccountType.Test]: "warning",
  [AccountType.Demo]: "info",
};

export const defaultFormValues: CompanyEditorFormData = {
  name: "",
  vat: "",
  country: "",
  companyType: CompanyType.Master,
  accountType: AccountType.Real,
  naceSectionId: "",
  naceDivisionId: null,
  ownershipSharePercentage: null,
  isPremiumActive: false,
  ownerEmail: "",
  ownerFirstName: "",
  ownerLastName: "",
  ownerPassword: "",
  ownerPhoneNumber: "",
};
